import axios from 'axios';
import { useInfiniteQuery, useQuery } from 'react-query';
import { SortBy } from 'src/types/api-general';

import {
  Something,
  SomethingResponse,
  SomethingsResponse,
} from 'src/types/something';

// Something
export function useSomething(id: Something['id']) {
  return useQuery<SomethingResponse, unknown, Something>(
    ['somethings', id],
    () => axios.get(`/api/somethings/${id}`),
    {
      select: (data) => data.data,
    }
  );
}

type UseSomethingsParams = {
  limit?: number;
  sort_by?: SortBy<keyof Something>[];
};
export function useSomethings(params: UseSomethingsParams = {}) {
  return useQuery<SomethingsResponse, unknown, Something[]>(
    ['somethings', params],
    () =>
      axios.get('/api/somethings', {
        params: {
          ...params,
          sort_by: params.sort_by?.join(','),
        },
      }),
    {
      select: (data) => data.data,
    }
  );
}

export function useInfiniteSomethings() {
  return useInfiniteQuery<SomethingsResponse, unknown, Something[]>(
    ['somethings'],
    ({ pageParam = 0 }) =>
      axios.get('/api/somethings', {
        params: {
          sort_by: 'createdAt.desc',
          limit: 20,
          offset: pageParam,
        },
      }),
    {
      getNextPageParam: (lastPage, pages) =>
        pages.reduce(
          (itemsCount, page) => itemsCount + page.data.length,
          lastPage.data.length
        ),
    }
  );
}
